export const DATE_FORMAT = 'YYYY/MM/DD';
export const MONTH_FORMAT = 'YYYY/MM';
export const REGEX_DATE = /^\d+(\/\d+)*$/;
export const REGEX_NUMBER_TIME = /^[0-9]{4}$/;
